/**
 * JSON-LD builders for landing v2. The output is meant to be inlined as a
 * <script type="application/ld+json"> child of <Head>.
 */

const ORIGIN = 'https://doocars.com';

export function organizationLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Doocars',
    url: ORIGIN,
    logo: `${ORIGIN}/icon-512.png`,
  };
}

export function websiteLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Doocars',
    url: ORIGIN,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${ORIGIN}/listings?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };
}

export function webPageLd({ title, description, canonical }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: title,
    description,
    url: canonical,
    isPartOf: { '@type': 'WebSite', url: ORIGIN },
  };
}

export function faqPageLd(items = []) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };
}

export function buildLandingLd({ seoTitle, seoDescription, canonical, faqItems }) {
  return [organizationLd(), websiteLd(), webPageLd({ title: seoTitle, description: seoDescription, canonical }), faqPageLd(faqItems)];
}

export function jsonLdScriptProps(payload) {
  return {
    type: 'application/ld+json',
    dangerouslySetInnerHTML: { __html: JSON.stringify(payload) },
  };
}
